module.exports = __webpack_public_path__ + "static/me-b38a48cdb49b0f7b7fa92c7a9a0ef76c.png";